/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CustomerCompanyInfoBlock = {
    CompanyDetails: 'COMPANY_DETAILS',
    Address: 'ADDRESS'
} as const;
export type CustomerCompanyInfoBlock = typeof CustomerCompanyInfoBlock[keyof typeof CustomerCompanyInfoBlock];

